window.Samcart.Embed.Core.registerModule('BuyNow', (function () {

    /**
     *
     * @constructor
     */
    function BuyNow() {

    }

    /**
     *
     * @type {string}
     */
    BuyNow.prototype.render_type =  'immediate';


    /**
     *
     * @param ele
     * @returns {boolean}
     */
    BuyNow.prototype.elementMatchesModule = function(ele) {
        return (ele.getAttribute('sc-embed') == 'button');
    };

    /**
     *
     * @param {string} marketplaceToken
     * @param {string} productSlug
     * @returns {string}
     */
    BuyNow.prototype.generateTag = function(marketplaceToken, productSlug) {
        return (marketplaceToken + '-' + productSlug + '-buynow').toLowerCase();
    };

    /**
     *
     * @param {Element} ele
     * @param {string} tag
     * @returns {string}
     */
    BuyNow.prototype.generateUrl = function(ele, tag) {
        var url = Samcart.Embed.Core.getBaseUrl() + 'embed/',
            productSlug = ele.getAttribute('sc-product') || ele.getAttribute('sc-button-product'),
            marketplace = ele.getAttribute('sc-marketplace') || ele.getAttribute('sc-button-marketplace'),
            backgroundColor = ele.getAttribute('sc-button-background-color'),
            textColor = ele.getAttribute('sc-button-text-color'),
            popup = ele.hasAttribute('sc-popup'),
            buttonText = ele.innerText;

        url += 'buynow_button?';
        url += 'tag=' + encodeURIComponent(tag);
        url += '&marketplace=' + encodeURIComponent(marketplace);
        url += '&slug=' + encodeURIComponent(productSlug);

        if (popup) {
            url += '&popup=true';
        }

        if (backgroundColor) {
            url += '&background_color=' + encodeURIComponent(backgroundColor);
        }

        if (textColor) {
            url += '&text_color=' + encodeURIComponent(textColor);
        }

        if (buttonText) {
            url += '&button_text=' + encodeURIComponent(buttonText);
        }

        return url;
    };

    /**
     *
     * @param {Element} ele
     * @param {string} tag
     */
    BuyNow.prototype.createComponent = function(ele, tag) {
        var url = this.generateUrl(ele, tag),
            width = ele.getAttribute('sc-button-width') || '288px';

        return xcomponent.create({
            tag: tag,
            url: url,
            scrolling: true,
            defaultLogLevel: 'error',
            prerenderTemplate: function(opts) {
                return null;
            },
            containerTemplate: function (opts) {
                return opts.jsxDom("div", {id: opts.id},
                    opts.jsxDom("style", null,
                        "#" + opts.id + " { position: relative; width: " + width + " !important; height: 92px !important; top: 0; bottom: 0; left: 0;}" +
                        "\n #" + opts.id + " .xcomponent-outlet {height: 100%; width: 100%; position: absolute; top: 0; left: 0; width: " + width + " !important; height: 92px !important;}" +
                        "\n #" + opts.id + " .xcomponent-outlet iframe { position: absolute; top: 0; left: 0; width: " + width + " !important; height: 92px !important;)"),
                    opts.outlet);
            }
        });
    };

    return new BuyNow();
})());